import React from "react";
import { Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { putRequest } from "../services/apiMethods";
const CustomerUpdatePassword = () => {
    const { mutate, isLoading: apiState } = useMutation({
      mutationFn: (data) => {
        const modifyData = {
          oldPassword: data?.oldPassword || "",
          newPassword: data?.confirmPassword || ""
        };
        return putRequest(`/profile/changePassword`, modifyData);
      },
      onSuccess: (data) => {
        toast.success(`${data?.message}`, {
          iconTheme: {
              primary: '#337FE0',
              secondary: '#FFFAEE',
          },
      })
      },
      onError: (error) => {
        console.error("Error during API call:", error);
      },
    });
  
  
    // Formik setup
    const formik = useFormik({
      initialValues: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      validationSchema: Yup.object({
        oldPassword: Yup.string()
          .required("Old Password is required"),
        newPassword: Yup.string()
          .required("New Password is required")
          .min(6, "Password must be at least 6 characters"),
        confirmPassword: Yup.string()
          .required("Please confirm your new password")
          .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
      }),
      onSubmit: (values) => {
        mutate(values);
      },
    });
  

  return (
    <Col lg={12} className="mt-5">
    <div className="my-profile-card-contain">
      <div className="my-profile-title">
        <h4>Password & Security</h4>
      </div>
      <div className="my-profile-box-contain">
        <div className="my-profile-box-form">
          <div className="form-box-title">
            <h4>Update Password</h4>
            <p>Update your account password.</p>
          </div>
          <div className="h-100 m-0">
            <form
              className="cmn-form-set"
              onSubmit={formik.handleSubmit}
            >
              <div className="mb-3">
                <label>Old Password</label>
                <input
                  type="password"
                  name="oldPassword"
                  placeholder="*********"
                  className="form-control"
                  value={formik.values.oldPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.oldPassword && formik.errors.oldPassword && (
                  <div className="text-danger">
                    {formik.errors.oldPassword}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label>New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  placeholder="*********"
                  className="form-control"
                  value={formik.values.newPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.newPassword && formik.errors.newPassword && (
                  <div className="text-danger">
                    {formik.errors.newPassword}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label>Re-Enter New Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="*********"
                  className="form-control"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <div className="text-danger">
                      {formik.errors.confirmPassword}
                    </div>
                  )}
              </div>

              <div className="d-flex gap-4">
                <button type="submit" className="theme-comm-btn">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Col>
  )
}

export default CustomerUpdatePassword
